
const NestedSelect = ({ child,level, nestedValue }) => {
    return (<>
        {child.label && <option value={child.value} >{"\u00A0\u00A0".repeat(level)}{child.label}</option>}
        {child.children &&
            child.children.map((child, index) => {
                return (
                    <NestedSelect child={child} level={level + 2}/>
                )
            })

        }
    </>
    )
}

export default NestedSelect;